import { ContactConfig } from '../../contact.types';

export default {
  links: [
    {
      label: 'Check out the Communications Hub for more resources',
      link: 'https://qnetconfluence.cms.gov/',
    },
  ],
  contactDetails: {
    hours: 'Available 24/7',
    days: 'Monday - Friday',
    email: 'ServiceCenterSOS@cms.hhs.gov',
    phone1: '1-866-288-8914',
    slack: '#help-service-center-sos',
  },
} as ContactConfig;
